'use client'

import { Divider, Text } from '@macarongfactory/web-ui'

import { EXTERNAL_LINKS } from '@/shared/lib'

import {
  HOME_COPY,
  HOME_TRACK_CODE,
  HOME_TRACK_LABEL,
  HOME_TRACK_TYPE,
  useHomeImpression,
  useHomeTracking,
} from '../_features/modoocar-home'

const HomeFooter = () => {
  const { itemShow } = useHomeTracking()

  const footerRef = useHomeImpression<HTMLElement>(() =>
    itemShow(
      HOME_TRACK_CODE.FOOTER,
      HOME_TRACK_TYPE.FOOTER,
      HOME_TRACK_LABEL.FOOTER
    )
  )

  return (
    <footer
      ref={footerRef}
      className='flex flex-col items-center gap-dimension-x4 bg-background-surface-basement px-dimension-x5 pb-dimension-x16 pt-dimension-x10'
    >
      <div className='flex items-center gap-dimension-x2'>
        <a
          href={EXTERNAL_LINKS.POLICY}
          target='_blank'
          rel='noopener noreferrer'
          className='px-dimension-x1-5 py-dimension-x1'
        >
          <Text
            variant='title-2-medium'
            color='text-foreground-neutral-alternative'
          >
            {HOME_COPY.footerTerms}
          </Text>
        </a>
        <Divider.Vertical height='x3' color='stroke-neutral-strong' />
        <a
          href={EXTERNAL_LINKS.PRIVACY_POLICY}
          target='_blank'
          rel='noopener noreferrer'
          className='px-dimension-x1-5 py-dimension-x1'
        >
          <Text
            variant='title-2-medium'
            color='text-foreground-neutral-alternative'
          >
            {HOME_COPY.footerPrivacy}
          </Text>
        </a>
      </div>
      <Text
        variant='caption-1-medium'
        color='text-foreground-neutral-assistive'
      >
        {HOME_COPY.footerCopyright}
      </Text>
    </footer>
  )
}

export default HomeFooter
